export default{
	login:{
		login:'登录',
		webName:'奔宝行',
		code:'获取手机验证',
		pwdPlaceholder:'请输入密码',
		codePlaceholder:'请输入验证码',
    refreshCode:'点击刷新验证码',
		pwdError:'密码不能为空！',
    codeError:'验证码不能为空！',
    codeError2:'请正确输入4位验证码！',
		phonePlaceholder:'请输入手机号码',
		phoneError1:'请输入手机号码!',
		phoneError2:'请输入正确的手机号',
		contact:'联系客服',
		QR:'公众号二维码',
		QRTxt:'关注公众号回复客服',
		confirm:'确定',
	},
	home:{
		home:'首页',
		numSearch:'号码搜索',
		notebook:'记事本',
    addNotebook:'新增记事本',
		feedback:'意见反馈',
		news:'消息',
		signOut:'退出',
		del:'删除',
		reply:'回复',
		edit:'编辑',
		permissions:'权限设置',
		open:'公开',
		oneself:'仅自己可见',
    administrator:'管理员',
		NotepadCon:'记事本内容',
		recordInfo:'让我们一起记录信息吧~',
		submit:'提交',
		cancel:'取消',
		notebookPlaceholder:'请输入您对广推的宝贵意见',
		picDesc:'图片描述',
		addPic:'添加图片',
		welcome:'欢迎使用奔宝行订货通',
		scan:'扫码开启',
		palm:'掌上广推奔宝',
		miniBg:'小程序背景墙',
	},
  routers:{
    login:'登录',
    home:'首页',
    partsCP:'配件',
    parts:'配件',
    partsDetails:'配件详情',
    VINsearch:'VIN搜索结果',
    cart:'购物车',
    shoppingCart:'购物车',
    count:'采购订单确认',
    countSale:'销售订单确认',
    lackGoods:'提交订单完成',
    successGoods:'提交订单成功',
    lackSuccessGoods:'提交订单完成',
    manageAddress:'管理地址',
    purchase:'采购订单',
    purchaseOrder:'采购订单',
    purchaseDetails:'采购订单详情',
    integralDetails:'积分订单详情',
    sale:'销售订单',
    saleOrder:'销售订单',
    otherSale:'销售订单（开思网销订单）',
    otherDetail:'订单详情（开思网销订单）',
    saleDetails:'销售订单详情',
    integralShop:'积分商城',
    integralShopCP:'积分商城',
    myPoints:'我的积分',
    stockControl:'库存管理',
    stock:'库存管理',
    customerManagement:'客户管理',
    returnGoods:'退货管理',
    returnCP:'退货管理',
    newPurchase:'新建采购退货单',
    newSale:'新建销售退货单',
    personalCenter:'个人中心',
    admin:'个人中心',
    editProfile:'编辑资料',
    purchaseChart:'采购统计分析',
    saleChart:'销售统计分析',
    sectorChart:'年度进货产品分类分析',
    posterBuilder:'海报生成器',
    posterEdit:'海报编辑',
    eCards:'电子名片',
    addOrEditECard:'生成电子名片',
  },
  table:{
    pic:'配件图片',
    PartsNum:'配件编号',
    PartsInfo:'配件信息',
    engine:'发动机',
    models:'车型',
    carSeries:'车系',
    price:'价格',
    stock:'库存',
    operate:'操作',
    oe:'OE',
    name:'名称',
    brand:'品牌',
    quality:'质量',
    area:'地区',
    seller:'销售公司',
    FOB:'含税价',
    remark:'备注',
    packaging:'包装信息',
    colour:'颜色',
    classify:'分类',
    packingMode:'装箱方式',
    type:'类型',
    years:'年份',
    assembly:'装配图',
    number1:'对照号',
    factory:'厂商',
    number2:'号码',
    record:'购买记录',
    orderNo:'订单号',
    date:'日期',
    quantity:'数量',
    unitPrice:'单价',
    questions:'相关问题',
    pInfo:'配件信息',
    quantityOrder:'订购数量',
    noData:'暂无数据',
    desc:'描述文字',
    totalPrice:'总计',
    writeComments:'请写下您的备注',
    add:'添加',
    checkAll:'全选',
    partTypes:'配件种类',
    totalQuantity:'数量总计',
    purchaseTotal:'采购订单总计',
    salesTotal:'销售订单总计',
    purchaseSettlement:'采购结算',
    salesSettlement:'销售结算',
    customerName:'客户名称',
    mobile:'手机号码',
    customerType:'客户类型',
    consignee:'收货人',
    detailedAddress:'详细地址',
    telephone:'固定电话',
    areaCode:'区号',
    extension:'分机号',
    telNumber:'电话号码',
    postcode:'邮编',
    priceY:'单价（元）',
    amount:'金额（元）',
    fittingName:'配件名称',
    total:'共计',
    orderStatus:'订单状态',
    orderDate:'订单日期',
    status:'状态',
    createTime:'生成时间',
    returnQuantity:'退货数量',
    refund_amount:'退款金额',
    finishTime:'完成时间',
    RMB:'￥',
    exchangeRate:'汇率',
  },
  parts:{
    parts:'配件',
    searchBar:'展开搜索栏',
    MSearch:'多功能搜索',
    KeywordSearch:'关键词搜索',
    aikeywordPlaceholder:'请输入配件关键词、自编号',
    search:'搜索',
    scan:'识别中',
    VINsearch:'车架号搜索',
    VINplaceholder:'请输入VIN号码',
    VINscan:'VIN识图',
    MultiNumSearch:'多号码搜索',
    numberlistP:`请输入OE号码，若多个OE号请按Enter键换行。示例：
11128645888
2218350064
51218402502`,
    empty:'清空',
    ImportExceldocuments:'导入Excel文档批量搜索',
    onlyExcel:'仅支持Excel格式',
    uploadFile:'选择需要上传的文件',
    downloadTemplate:'下载模板',
    classifiedSearch:'分类搜索',
    keywordsFilter:'输入关键字进行过滤',
    allParts:'全部配件',
    sub:'我的收藏',
    hot:'热买',
    available:'有货',
    stockArrival:'缺货到货',
    new:'新品',
    ExportAll:'导出全部',
    ExportExcel:'导出excel',
    Brand:'品牌',
    carSeries:'车系',
    carModel:'车型',
    ownProducts:'自有产品',
    customerNum:'客户号',
    recommend:'荐',
    aBoxful:'一箱',
    dealerPrice:'单价',
    // peerPrice:'同行价格',
    repairPrice:'建议销售单价',
    buy5:'买5送1',
    buy6:'加入6件，仅5件价格',
    myStock:'我的库存',
    on_way_stock:'在途库存',
    otherDealers:'其他经销商',
    details:'详情',
    buy:'购买',
    marketPric:'市场价格查询',
    brandScreening:'品牌筛选',
    unselect:'取消选择',
    inTheArea:'所在地区',
    otherDealer:'其他经销商库存',
    dealerName:'经销商名称',
  },
  partsDetails:{
    partsDetails:'配件详情',
    newPage:'详情新视窗',
    sub:'收藏配件',
    sellingPrice:'建议出售单价',
    ask:'提问',
    citizens:'热心市民',
    batchNum:'批次号',
    noQuestions:'暂无用户提问',
    videos:'相关视频',
    noVideos:'暂无相关视频',
    addNum:'新增对照号',
    askQuestions:'我要提问',
    qestionsType:'问题类型',
    selectQuestion:'请选择问题类型',
    cQuestion:'咨询问题',
    pdFeedback:'产品反馈',
    newNumber:'最新号码',
    pdBatch:'选填，请输入产品批次号',
    problemDesc:'问题描述',
    problemDescPlaceholder:'请输入您对这个产品的问题或疑问',
    supplementaryDesc:'补充描述',
    addpic:'添加图片',
    newProduct:'新品',
    PackageDetails:'套装明细',
    PackageNum:'套装号',
    ItemNum:'单品号',
    ItemName:'单品名称',
    adaptationOE:'单品适配OE号',
  },
  VINsearch:{
    VINsearch:'VIN搜索结果',
    VehicleInfo:'车辆信息',
    Transmission:'变速箱',
    frame:'车架',
    AdditionalInstructions:'附加说明',
    ReplacementNumber:'替换号',
    Sprices:'4S店价格',
    dosage:'用量',
    StandardName:'标准名',
    VINP:'请输入正确VIN',
  },
  cart:{
    cart:'购物车',
    selectCustomers:'选择客户',
    subAaccount:'子账号筛选',
    quotationSetting:'报价设置',
    quotingTheSellingPrice:'按建议销售价格报出',
    purchasePriceMarkupRateQuoted:'按采购价*加价率报出',
    copyOfQquotation:'一键复制报价',
    oneClickCollection:'一键收藏配件',
    emptyCart:'清空购物车',
    subtotal1:'经销商小计',
    subtotal2:'销售小计',
    toCustomer:'前往客户管理',
    searchCustomers:'搜索客户',
    noCustomerInfo:'暂无客户信息，可前往客户管理添加客户信息',
    selectAcustomer:'请选择客户',
    successMsg:'操作成功',
    errorMsg:'操作失败',
    delGoods:'是否删除选中商品？',
    tip:'提示',
    delGoods2:'请选择要删除商品',
    includeNnonIntegral:'结算时请包含 非积分 商品！',
    selectAcommodity:'请选择商品',
    onlyFreyCurrency:'N币仅 采购结算 可用！',
    selectCollect:'请选择需要收藏的产品！',
    selectAddress:'选择收货地址',
    integralPrice:'积分价格',
    freyCoin:'N币',
    logisticsInfoP:'请输入物流发货信息',
    selectLogisticsP:'请选择物流信息',
    monthlyPayment:'交易方式：挂账月结',
    totalSalesOrders:'销售订单共计',
    yuan:'元',
    returnCart:'返回购物车',
    freyIntegralTotal:'N积分总计',
    submitOrder:'提交订单',
    submittedSuccessfully:'订单提交成功',
    orderDetails:'订单详情',
    continueToBuy:'继续购买',
    orderTipsCon1:'尊敬的顾客，您的订单已提交成功，',
    orderTipsCon2:'请进入订单列表或下面订单详情确认订单，',
    orderTipsCon3:'我们将尽快安排货物配送，感谢您的支持！',
    submissionCompleted:'订单提交完成',
    completedTip:'尊敬的顾客，您的提交的配件订单暂无库存！您可以在平台的订单里面查看订单的状态，请及时关注，感谢您的支持!',
    lackSuccessGoodsTipsCon1:'尊敬的顾客，您提交的以下配件订单成功，',
    completedTip2:'尊敬的顾客，您的提交的以下配件订单暂无库存！您可以在平台的订单里面查看订单的状态，请及时关注，感谢您的支持!',
    yourRequirements:'请输入您的要求',
  },
  manageAddress:{
    addressManage:'管理地址',
    defAaddress:'默认地址',
    setDefault:'设为默认',
    modify:'修改',
    addAddress:'新增地址',
    modificationAddressrt:'修改地址',
    selectLocation:'请选择所在地',
    setAsDefaultAddr:'设为默认地址',
    deliveryAddress:'收货地址',
    customerInfoModifi:'客户信息修改',
    fillConsignee:'请填写收货人',
    fillAddress:'请填写详细地址',
    errorMobile:'手机格式错误',
    telephoneCorrectly:'请正确填写固定电话',
    selectAddress2:'请选择地址',
    addGoods:'请添加商品',
    pAddAddress:'请添加地址',
    delUser:'是否要删除该用户？',
  },
  purchase:{
    purchase:'采购',
    filterSearch:'筛选搜索',
    orderQuery:'订单查询',
    reset:'重置',
    submissionTime:'提交时间',
    orderNumP:'请输入订单编号',
    orderStatusP:'请选择订单状态',
    submissionTimeP:'请选择提交时间',
    orderTime:'下单时间',
    eDeliveryDate:'预计发货日期',
    orderQuantity:'下单件数',
    actualQuantity:'实发件数',
    orderTotal:'下单总计',
    actualTotal:'实发总计',
    logisticsInfo:'物流信息',
    confirmOrder:'确认订单',
    confirmReceipt:'确认收货',
    submitReconciliation:'提交对账',
    cancelTheOrder:'取消订单',
    buyAgain:'再次购买',
    integralOrder:'积分订单',
    addcart:'添加到购物车',
    draft:'草稿',
    confirmed:'已确认',
    audited:'已审核',
    alreadyPaid:'已付款',
    pickedUpGoods:'已捡货',
    packed:'已打包',
    loadedCar:'已装车',
    receivedGoods:'已收货',
    reconciled:'已对账',
    finished:'已完成',
    returnedGoods:'已退货',
    stockouts:'缺货',
    delete:'删除',
    isCancelOrder:'确定要取消订单？',
    exportOrder:'导出订单',
    receivingInfo:'收货信息',
    address:'地址',
    distributionInfo:'配送信息',
    outboundOrder:'出库单号',
    packagesNum:'件数',
    orderInfo:'订单信息',
    customerReconciliation:'客户对账',
    OneClickReconciliation:'一键对账',
    serialNum:'序号',
    actualQuantity:'实发数',
    checkAccounts:'对账',
    confirmReconciliation:'确认对账',
    settlementMethod:'结算方式',
    monthlyAccount:'挂账月结',
    expectedToEarnPoints:'预计可获得积分',
    cent:'分',
    rebateAmount:'返利金额',
    commodityDelivery:'商品出库',
    financialReconciliation:'财务对账',
    receiving:'一键收货',
  },
  stock:{
    shareInventoryDealers:'勾选下方按钮，即可与广大经销商共享配件库存',
    sharedInventory:'共享库存',
    downloadInventory:'点击下载库存导入模板填写，即可上传更新库存',
    clickUpload:'点击上传',
    importSucceeded:'导入成功',
    successfullyImported:'库存导入成功，可下载导入结果库存',
    downloadIInventory:'下载导入库存',
    close:'关闭',
    importFailed:'导入失败',
    failedCheck:'库存导入失败，请检查导入格式是否正确',
    stock:'库存',
  },
  returnGoods:{
    returnGoods:'退货',
    applicationTime:'申请时间',
    selectAtime:'请选择时间',
    applicationStatus:'申请状态',
    selectApplicationStatus:'请选择申请状态',
    newReturnOrder:'新建退货单',
    draftreturnOrder:'草稿退货单',
    totalReturn:'退货总计',
    reasonReturn:'退货原因',
    salesReturnDetails:'销售退货订单详情',
    purchaseDetails:'采购退货订单详情',
    returnOrder:'退货订单',
    accessoriesSearch:'配件搜索',
    accessoryNumber:'请输入配件编号',
    draftRreturnOrder:'退货单草稿箱',
    generateReturnOrder:'生成退货单',
    addToReturnOrder:'添加至退货单',
    selectReturnReason:'请选择退货原因',
    otherReasons:'其他退货原因',
    enterReturnReason:'请输入退货原因',
    confirmAdd:'确定添加',
    returnOrderGenerated:'您好，您的退货单已生成',
    returnProgressTip:'我们将持续与您关注退货进度，感谢支持！',
    viewOrders:'查看订单',
    enterReturnedQuantity:'请输入退货数量',
    wantConfirm:'是否要确认？',
    wantDelete:'确定要删除该记录？',
    noRecordsDel:'没有可删除记录',
    wantEmptRecord:'确定要清空记录？',
    returnGoods:'returnGoods',
  },
  personalCenter:{
    personalCenter:'个人中心',
    accountSetting:'账户设置',
    posterGenerator:'海报生成器',
    lastLogin:'最后登录',
    addAccountNumber:'新增账号',
    only10Sub:'仅可添加10个子账号',
    accountNumber:'帐号',
    fullName:'姓名',
    addTime:'添加时间',
    jurisdiction:'权限',
    editAccount:'编辑账号',
    subAccount:'子帐号',
    setPassword:'设置密码',
    isDisabled:'是否禁用',
    financial:'财务',
    priceInquiry:'价格查询',
    entersubAccount:'请输入子账号手机号码',
    enterName:'请输入姓名',
    setPasswordP:'请设置密码',
    p3Digits:'密码不能小于3位',
    selectLeastOnePermission:'请至少选择一个权限',
    sell:'销售',
    avatar:'头像',
    onlyJPG:'仅支持JPG、PNG格式，文件小于1M',
    uploadAvatar:'上传新头像',
    permissionSelection:'权限选择',
    accountPassword:'账号密码',
    modifyPassword:'修改密码',
    save:'保存',
    originalPassword:'原密码',
    newPassword:'新密码',
    confirmPassword:'确认新密码',
    originalPasswordP:'请输入原密码',
    newPasswordP:'请输入新密码',
    passwordAgainP:'再次输入新密码',
    correctUsername:'请输入正确的用户名',
    twicePasswords:'两次输入密码不一致',
    onlyJPGPNG:'上传头像图片只能是 JPG、PNG格式!',
    exceed1MB:'上传头像图片大小不能超过 1MB!',
    editNow:'立即编辑',
    returns:'返回',
    copy:'复制',
    download:'下载',
    companyName:'公司名称',
    serviceHotline:'服务热线',
    product:'产品',
    pleaseEnter:'请输入',
    contactAddress:'联系地址',
    QRcode:'二维码',
    replace:'替换',
    generatePreview:'生成预览',
    replaceProduct:'替换产品',
    keywordsNum:'配件关键词/号码',
    noData:'暂无数据',
    pictureNotBeenLoaded:'图片暂未加载完成!请稍后...',
    personalCenter:'个人中心',
  },
  integralMall:{
    Hello:'您好',
    earnPoints:'签到赚积分',
    PointsRule:'积分规则',
    exchange:'兑换',
    RedeemNow:'立即兑换',
    lookAgain:'再看看',
    CurrentPoints:'当前积分',
    checkIn:'每日签到',
    Points1:'1.连续签到第1天 - 第6天：每日签到积分+1；',
    Points2:'2.连续签到一周：获得5积分；',
    Points3:'3.连续签到两周：获得10积分；',
    Points4:'4.以此类推每周额外增加5积分,最多获得30积分；',
    Points5:'5.当连续签到中断后，则回到初始签到状态重新累计连续签到天数；',
    ProductExchange:'商品兑换',
    Pd1:'1.积分商品只能使用N币进行兑换,不能直接使用积分进行兑换；',
    Pd2:'2.N币由积分进行兑换,N币与积分比例为:1:100；',
    Pd3:'3.订单中不能只有积分商品存在,必须有配件产品也在订单中；',
    Pd4:'4.凡是在本次购买的积分商品都会在下次与配件产品发货时一起运送过来；',
    Pd5:'5.逾期账款未清，不进行积分礼品兑换；',
    current:'当前',
    ProductDetails:'商品详情',
    PointPrice:'积分价格',
    AddToCart:'加入购物车',
    ProductDescription:'商品介绍',
    // nibd:'耐博得',
    coin:'币',
    my:'我的',
    nibdCoin:'N币',
    exchangeNibdCoin:'兑换N币',
    myNnibdCoin:'我的N币',
    currentNibdCoin:'当前N币',
    insufficient:'您好！您的N币不足，请前往兑换N币',
    TotalPoints:'积分总数',
    pointsUused:'已用积分总数',
    availablePoints:'可用积分总数',
    AvailableNibdCoins:'可用N币',
    ConvertedToNibdCoin:'已兑换N币',
    ConvertibleNibdCoin:'可兑换N币',
    UsedNibdCoin:'已用N币',
    source:'来源',
    describe:'描述',
    points:'积分',
    specs:'规格',
  }
}



// WEBPACK FOOTER //
// ./src/locale/zh.js